"use strict";

var units = ['', 'ribu', 'juta', 'milyar', 'triliun', 'quadriliun', 'quintiliun', 'sextiliun', 'septiliun', 'oktiliun', 'noniliun', 'desiliun', 'undesiliun', 'duodesiliun', 'tredesiliun', 'quattuordesiliun', 'quindesiliun', 'sexdesiliun', 'septendesiliun', 'oktodesiliun', 'novemdesiliun', 'vigintiliun'];
var maxIndex = units.length - 1;
function digitToUnit(digit) {
  var curIndex = digit / 3;
  return curIndex <= maxIndex ? units[curIndex] : units[maxIndex];
}
var numbers = ['', 'satu', 'dua', 'tiga', 'empat', 'lima', 'enam', 'tujuh', 'delapan', 'sembilan'];
function numberToText(index) {
  return numbers[index] || '';
}
var terbilang = function terbilang(angka) {
  var angkaLength = angka.length;
  var angkaMaxIndex = angkaLength - 1;

  // Angka Nol
  if (angkaMaxIndex === 0 && Number(angka[0]) === 0) {
    return 'nol';
  }
  var space = '';
  var result = '';
  var i = 0;
  while (i !== angkaLength) {
    var digitCount = angkaMaxIndex - i;
    var modGroup = digitCount % 3; // [2,1,0]
    var curAngka = Number(angka[i]);
    if (digitCount === 3 && curAngka === 1 && (i === 0 || Number(angka[i - 2]) === 0 && Number(angka[i - 1]) === 0)) {
      /* Angka Seribu */
      result += "".concat(space, "seribu");
    } else {
      if (curAngka !== 0) {
        if (modGroup === 0) {
          /* Angka Satuan Bukan Nol */
          result += "".concat(space).concat(numberToText(curAngka)).concat(i === angkaMaxIndex ? '' : ' ').concat(digitToUnit(digitCount));
        } else if (modGroup === 2) {
          /* Angka Ratusan */
          if (curAngka === 1) {
            result += "".concat(space, "seratus");
          } else {
            result += "".concat(space).concat(numberToText(curAngka), " ratus");
          }
        } else {
          /* Angka Sepuluh dan Belasan */
          if (curAngka === 1) {
            i++; // Skip Next Angka
            var nextAngka = Number(angka[i]);
            if (nextAngka === 0) {
              result += "".concat(space, "sepuluh");
              /* Proses Next Angka Sekarang */
              if (digitCount !== 1 && (Number(angka[i - 2]) !== 0 || Number(angka[i - 1]) !== 0)) {
                result += " ".concat(digitToUnit(digitCount - 1));
              }
            } else {
              if (nextAngka === 1) {
                result += "".concat(space, "sebelas");
              } else {
                result += "".concat(space).concat(numberToText(nextAngka), " belas");
              }
              /* Proses Next Angka Sekarang */
              if (digitCount !== 1) {
                result += " ".concat(digitToUnit(digitCount - 1));
              }
            }
          } else {
            /* Angka Puluhan */
            result += "".concat(space).concat(numberToText(curAngka), " puluh");
          }
        }
      } else {
        /* Angka Satuan Nol */
        if (modGroup === 0 && (Number(angka[i - 2]) !== 0 || Number(angka[i - 1]) !== 0) && digitCount !== 0) {
          result += " ".concat(digitToUnit(digitCount));
        }
      }
    }
    if (i <= 1) {
      space = ' ';
    }
    i++;
  }
  return result;
};
var terbilangSatuSatu = function terbilangSatuSatu(angka) {
  return angka.split('').map(function (angka) {
    return angka == 0 ? 'nol' : numberToText(angka);
  }).join(' ');
};
module.exports = function angkaTerbilang(target) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    decimal: '.'
  };
  if (typeof target !== "string") target = String(target);
  if (target.indexOf(settings.decimal) > -1) {
    /* Dengan Desimal */
    target = target.split(settings.decimal);
    return "".concat(terbilang(target[0]), " koma ").concat(terbilangSatuSatu(target[1]));
  } else {
    /* Tanpa Desimal */
    return terbilang(target);
  }
};